// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1Hd8v","checkboxCol":"Table_checkboxCol__bsxed","emailCol":"Table_emailCol__Ut1tr","actionCol":"Table_actionCol__29pbQ"};